import React from 'react'
import {Modal, ModalBody, ModalHeader} from 'reactstrap'
import PropTypes from 'prop-types'
import GridSettingsForm from './SettingsForm'

const propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  afterSubmit: PropTypes.func.isRequired
}

const SettingsModal = ({isOpened, onCancel, afterSubmit}) => {
  return (
    <Modal id="grid-settings-modal" isOpen={isOpened} className="modal-primary">
      <ModalHeader>Application settings</ModalHeader>
      <ModalBody>
        <GridSettingsForm onCancel={onCancel} afterSubmit={afterSubmit}/>
      </ModalBody>
    </Modal>
  )
}

SettingsModal.propTypes = propTypes

export default SettingsModal



// WEBPACK FOOTER //
// ./src/components/Profile/settings/SettingsModal.js